import axios from "axios"

import { authService } from "@/utils/auth/authService"
import { HTTP_STATUS } from "@/utils/constants/http"

/**
 * Builds the Authorization header from the current auth token.
 * Mirrors the request interceptor so it can be reused for SSE / fetch.
 */
export const getAuthHeaders = () => {
  const token = authService.getToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

/**
 * Handles 401 / 403 responses outside of axios (e.g. for SSE / fetch).
 * Mirrors the response interceptor.
 */
export const handleAuthError = status => {
  if (status === HTTP_STATUS.UNAUTHORIZED) {
    authService.clearToken()
    window.dispatchEvent(new CustomEvent("auth:unauthorized"))
  }

  if (status === HTTP_STATUS.FORBIDDEN) {
    window.dispatchEvent(new CustomEvent("auth:forbidden"))
  }
}

/**
 * Configured axios instance
 */
const createApiClient = (baseURL = window.BACKEND_URL) => {
  const client = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json; charset=UTF-8"
    },
    paramsSerializer: {
      indexes: null
    }
  })

  client.interceptors.request.use(
    config => {
      Object.assign(config.headers, getAuthHeaders())
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  client.interceptors.response.use(
    response => response,
    error => {
      handleAuthError(error.response?.status)
      return Promise.reject(error)
    }
  )

  return client
}

export const apiClient = createApiClient(window.BACKEND_URL)
export const httpDeployClient = createApiClient(window.HTTP_DEPLOY_URL)
export const hawkbitClient = createApiClient(window.HAWKBIT_URL)

export default apiClient
